import { InjectionToken } from '@angular/core';

export const AUTH_LOGIN_ROUTE = new InjectionToken<string[]>('PV_AUTH_LOGIN_ROUTE', {
  providedIn: 'root',
  factory: () => ['/auth/login'],
});
